import React from 'react'
import {injectIntl} from 'react-intl'
import styled from 'styled-components'
import DialogActions from '@mui/material/DialogActions'
import DialogContent from '@mui/material/DialogContent'
import DialogTitle from '@mui/material/DialogTitle'
import Button from '@mui/material/Button'
import TextField from '@mui/material/TextField'
import Alert from 'components/Alert'
import {getFieldsPdf, getEntityFieldsPdf, openTemplate} from 'utils/utils'
import Field from './Field'

const Input = styled.input`
    opacity: 0;
    width: 0;
`

const TextInput = styled(TextField)`
	width: 100%;

	&:not(:last-child) {
		margin-bottom: 20px;
	}
`

class TemplatePdf extends React.Component {
    constructor(props) {
        super(props)

        this.entityFields = getEntityFieldsPdf(props.entity)

        this.state = {
            name: props.template ? props.template.name : '',
            file: props.template ? props.template.fileName : '',
            mapping: props.template ? props.template.mapping : null
        }
    }

    handleDownload = async (e) => {
        const file = e.currentTarget.files[0]

        if (file) {
            const fields = await getFieldsPdf(file)

            if (fields) {
                const mapping = fields.map(item => {
                    return {
                        pdfField: item,
                        pathId: this.entityFields[0].pathId,
                        empty: false
                    }
                })

                this.setState({
                    file: file.name,
                    mapping
                })
            }
        }
    }

    handleSelect = (value, field, option) => {
        const mapping = [...this.state.mapping]
        const index = mapping.findIndex(item => item.pdfField === field)
        const obj = {...mapping.find(item => item.pdfField === field)}
        obj[option] = value

        if (option === 'empty') {
            obj.pathId ? obj.pathId = null : obj.pathId = this.entityFields[0].pathId
        }
        
        mapping.splice(index, 1, obj)

        this.setState({ mapping })
    }

    handleChange = (e) => {
        this.setState({
            [e.target.name]: e.target.value
        })
    }

    exportPdf = () => {
        this.props.template ?
            this.props.exportPdf({
                id: this.props.template.id,
                entityId: this.props.template.entityId,
                name: this.state.name,
                fileName: this.props.template.fileName,
                mapping: this.state.mapping
            }) :
            this.props.exportPdf({
                entityId: this.props.entity,
                name: this.state.name,
                fileName: '',
                mapping: this.state.mapping
            }, this.input.files[0])
    }

    deletePdfTemplate = () => {
        this.props.deletePdfTemplate(this.props.template.id)
        this.props.handleClose()
    }

    openTemplate = async () => {
        await openTemplate(this.props.template.id)
    }

    render() {
        const { intl, template, documentsCount } = this.props
        const validation = this.state.name.replace(/\s/g, '') === '' ||
            !this.state.mapping || (this.state.mapping && !this.state.mapping.length)
        const error = this.state.mapping && !this.state.mapping.length

        return (
            <React.Fragment>
                <DialogTitle>{intl.formatMessage({id: "sidebar.create_pdf_template"})}</DialogTitle>
                <DialogContent>
                    {documentsCount > 5 &&
                        <Alert text={intl.formatMessage({id: "sidebar.pdf_template_documents_count"})} />
                    }
                    <TextInput variant="standard"
                        value={this.state.name}
                        onChange={this.handleChange}
                        label={intl.formatMessage({id: "sidebar.template_name"})}
                        InputLabelProps={{
                            shrink: true
                        }}
                        inputProps={{
                            maxLength: global.NAME_MAX_LENGTH,
                            name: 'name'
                        }}
                    />
                    {!template &&
                        <TextInput variant="standard"
                            label={intl.formatMessage({id: "sidebar.pdf_file"})}
                            placeholder={intl.formatMessage({id: "sidebar.click_to_upload"})}
                            InputProps={{
                                readOnly: true
                            }}
                            InputLabelProps={{
                                shrink: true
                            }}
                            onClick={() => this.input.click()}
                            value={this.state.file}
                            error={error}
                            helperText={error ? intl.formatMessage({id: "sidebar.file_error"}) : ''}
                        />
                    }
                    <Input type='file'
                        onChange={this.handleDownload}
                        ref={el => this.input = el}
                        accept=".pdf"
                    />
                    {this.state.mapping && !!this.state.mapping.length &&
                        <div>
                            {this.state.mapping.map((item, index) =>
                                <Field key={index}
                                    mapping={item}
                                    entityFields={this.entityFields}
                                    handleChange={this.handleSelect}
                                />
                            )}
                        </div>
                    }
                    {template &&
                        <Button variant="contained"
                            onClick={this.openTemplate}
                            style={{background: '#4cae4c', color: '#FFF', marginTop: '20px', display: 'block'}}
                        >
                            {intl.formatMessage({id: "sidebar.show_template"})}
                        </Button>
                    }
                </DialogContent>
                <DialogActions>
                    <Button onClick={this.props.handleClose} color="primary">
                        {intl.formatMessage({id: "app.confirm_cancel"})}
                    </Button>
                    {this.props.template &&
                        <Button variant="contained"
                            onClick={this.deletePdfTemplate}
                            color="secondary"
                        >
                            {intl.formatMessage({id: "app.confirm_delete"})}
                        </Button>
                    }
                    <Button variant="contained"
                        disabled={validation}
                        onClick={this.exportPdf}
                        color="primary"
                    >
                        {intl.formatMessage({id: documentsCount ?
                            "app.confirm_save_export" : "app.confirm_save"})}
                    </Button>
                </DialogActions>
            </React.Fragment>
        )
    }
}

export default injectIntl(TemplatePdf)
